export enum MenstrualPhase {
    NONE = 'None',
    FOLLICULAR = 'Follicular',
    OVULATION = 'Ovulation',
    LUTEAL = 'Luteal'
}